export const ACTIVITY_FORM_MODULE_ID = 'activity-form-module';

export const LOAD_ACTIVITY_FORM_MODULE = () => import('@capital-access/activity/form').then(m => m.ActivityFormModule);
